<template>
  <div style="padding: 0">
    <el-input style="vertical-align:middle;" :disabled="disabled" @focus="searchData()" v-model="myPlantName" clearable v-if="formSign!=='sensoryReportDetail'&&formSign!=='processSensoryReportDetail'"></el-input>
    <el-dialog append-to-body :title="$t('sensory.report.FactorySelector')" :visible="showPickupDialog" @close="showPickupDialog = false" width="91%" class="dialog">
      <div class="table">
        <div class="container">
          <div class="handle-box">
            <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="Level1 Category" prop="categoryLevel1Code">
                    <ic-select clearable disabled table="BASE" filterable field="CATEGORY_LEVEL1" @change="queryCondition.categoryLevel2Code=null,queryCondition.categoryLevel3Code=null" v-model="queryCondition.categoryLevel1Code"></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="Level2 Category" prop="categoryLevel2Code">
                    <ic-select clearable :disabled="categoryLevel2Code" table="BASE" filterable :field="queryCondition.categoryLevel1Code" @change="queryCondition.categoryLevel3Code=null" v-model="queryCondition.categoryLevel2Code"></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="Level3 Category" prop="categoryLevel3Code">
                    <ic-select clearable :disabled="categoryLevel3Code" :table="queryCondition.categoryLevel1Code" filterable :field="queryCondition.categoryLevel2Code" v-model="queryCondition.categoryLevel3Code"></ic-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="$t('base.plant.plantNo')" prop="plantNo">
                    <el-input clearable v-model.trim="queryCondition.plantNo" />
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item :label="$t('base.plant.plantName')" prop="plantName">
                    <el-input clearable v-model.trim="queryCondition.plantName" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="$t('base.eightBitCode.eightBitCode')" prop="eightBitCode">
                    <el-input clearable v-model.trim="queryCondition.eightBitCode" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('base.eightBitCode.eightBitCodeName')" prop="eightBitCodeName">
                    <el-input clearable v-model="queryCondition.eightBitCodeName" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('base.fiveBitCode.title')" prop="fiveBitCode">
                    <el-input clearable :disabled="fiveBitCode" v-model.trim="queryCondition.fiveBitCode" />
                  </el-form-item>
                </el-col>

              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="$t('base.fiveBitCode.name')" prop="fiveBitCodeName">
                    <el-input clearable v-model.trim="queryCondition.fiveBitCodeName" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" justify="center">
                <el-col :span="4">
                  <el-button @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
                  <el-button @click="restForm()" type="primary">{{$t('common.reset')}}</el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <el-row style="margin-bottom:20px">
            <el-button @click="pickUpMaterial" type="primary">{{$t("common.select")}}</el-button>
          </el-row>
          <el-table :data="tableData" ref="dataList" border highlight-current-row class="table" max-height="400">
            <el-table-column :label="$t('common.select')" align="center" width="50">
              <template slot-scope="scope">
                <el-radio v-model="radioVal" @change.native="changeSelect(scope.row)" :label="scope.row.tmMaterialId">&nbsp;</el-radio>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="categoryLevel1Name" sortable label="Level1 Category"></el-table-column>
            <el-table-column show-overflow-tooltip prop="categoryLevel2Name" sortable label="Level2 Category"></el-table-column>
            <el-table-column show-overflow-tooltip prop="categoryLevel3Name" sortable label="Level3 Category"></el-table-column>
            <el-table-column show-overflow-tooltip prop="plantNo" sortable :label="$t('base.plant.plantNo')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="plantName" sortable :label="$t('base.plant.plantName')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="eightBitCode" width="90" sortable :label="$t('base.eightBitCode.eightBitCode')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="eightBitCodeName" sortable :label="$t('base.eightBitCode.eightBitCodeName')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="fiveBitCode" sortable :label="$t('base.fiveBitCode.title')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="fiveBitCodeName" sortable :label="$t('base.fiveBitCode.name')"></el-table-column>
          </el-table>
          <div class="pagination">
            <!--===分页组件===-->
            <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import commonFunction from "../../../utils/dataTableUtils"
import { materialService } from "../../../api/base-data/material";
import IcSelect from "@/components/common/icSelect";
import SelDc from '../base-data/dc-sel-page'
import { Message } from "element-ui";
import commonMethods from "@/utils/commonMethods";

export default {
  name: 'pickupPlant',
  components: { IcSelect, SelDc },
  props: {
    formSign: {
      type: String,
      default: null,
    },
    needRemove: {
      type: Boolean,
      default: true,
    },
    value: {
      type: String,
      default: null,
    },
    plantName: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fiveBitCode: {
      type: String,
      default: null
    },
    fiveBitCodeName: {
      type: String,
      default: null
    },
    categoryLevel1Code: {
      type: String,
      default: "10"
    },
    categoryLevel2Code: {
      type: String,
      // default: null
    },
    categoryLevel3Code: {
      type: String,
      default: null
    },
    pickUpPlantObj: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      myPlantName: this.plantName,
      tableData: [],
      totalCount: 0,
      queryCondition: {
        categoryLevel1Code: this.categoryLevel1Code,
        categoryLevel2Code: this.categoryLevel2Code,
        categoryLevel3Code: this.categoryLevel3Code,
        plantNo: "",
        plantName: "",
        eightBitCode: "",
        eightBitCodeName: "",
        fiveBitCode: this.fiveBitCode,
        fiveBitCodeName: "",
        pageSize: 15,
        pageNum: 1
      },
      showSelDcDialog: false,
      tempRows: null,
      showPickupDialog: false,
      radioVal: null,
      selectRow: null,
    }
  },
  methods: {
    searchData() {
      this.queryCondition.categoryLevel1Code = this.categoryLevel1Code;
      this.queryCondition.categoryLevel2Code = this.categoryLevel2Code;
      this.queryCondition.categoryLevel3Code = this.categoryLevel3Code;
      this.queryCondition.fiveBitCode = this.fiveBitCode;
      this.queryCondition.fiveBitCodeName = "";
      this.showPickupDialog = true;
      this.queryData();
    },
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      materialService.materialList(this.queryCondition).then((res) => {
        this.tableData = res.data.records;
        this.totalCount = res.data.total;
      });
    },
    changeSelect(row) {
      this.selectRow = row;
    },
    pickUpMaterial() {
      let selection = this.selectRow;
      this.$emit("pick-up", selection);
      this.$emit("update:plantName", selection.plantName);
      this.dispatchFormValide(selection.plantName);
      this.myPlantName = selection.plantName;
      this.showPickupDialog = false;
    },
    restForm() {
      if (!this.categoryLevel1Code) {
        this.queryCondition.categoryLevel1Code = ''
      }
      if (!this.categoryLevel2Code) {
        this.queryCondition.categoryLevel2Code = ''
      }
      if (!this.categoryLevel3Code) {
        this.queryCondition.categoryLevel3Code = ''
      }
      if (!this.fiveBitCode) {
        this.queryCondition.fiveBitCode = ''
      }
      this.queryCondition.fiveBitCodeName = ''
      this.queryCondition.plantNo = ""
      this.queryCondition.plantName = ""
      this.queryCondition.eightBitCode = ""
      this.queryCondition.eightBitCodeName = ""
      this.queryCondition.pageSize = 15
      this.queryCondition.pageNum = 1
      this.radioVal = ''
      this.queryData();
    }
  },
  watch: {
    plantName(newVal, oldVal) {
      this.myPlantName = newVal;
    },
    fiveBitCode(val) {
      this.queryCondition.fiveBitCode = val;
    },
    // fiveBitCodeName(val) {
    //   this.queryCondition.fiveBitCodeName = val;
    // },
    categoryLevel1Code(val) {
      this.queryCondition.categoryLevel1Code = val;
    },
    categoryLevel2Code(val) {
      this.queryCondition.categoryLevel2Code = val;
    },
    categoryLevel3Code(val) {
      this.queryCondition.categoryLevel3Code = val;
    },
    pickUpPlantObj: {
      handler(newV) {
        console.log("GY🚀 ~ file: pickupPlant.vue:159 ~ handler ~ newV:", newV);
        if (newV) {
          var res = JSON.parse(newV)
          this.queryCondition.categoryLevel1Code = res.categoryLevel1Code;
          this.queryCondition.categoryLevel2Code = res.categoryLevel2Code;
          this.queryCondition.categoryLevel3Code = res.categoryLevel3Code;
          this.queryCondition.fiveBitCode = res.fiveBitCode;
          this.queryCondition.fiveBitCodeName = "";
          this.queryData();
        }
      },
      immediate: true
    }
  },
  extends: commonFunction
}
</script>
<style scoped  lang="scss">
.el-select {
  width: 100%;
}
</style>
